@if (multiple()) {
  <!-- In CwDropdown the property "multiple" cannot be set programmatically -->
  <!-- we use custom shadow CSS for assistive text, by default cannot grow. But here we need to allow it   -->
  <cw-dropdown
    customShadowCss
    [styles]="safariFix + ' ' + assistiveTextFix"
    [attr.data-vef]="attrVef()"
    [value]="inputTextValue()"
    [placeholder]="placeholder()"
    [label]="label()"
    [assistiveText]="assistiveText() || error()"
    [status]="status() || (error() ? 'error' : null)"
    [required]="required()"
    [readonly]="readonly()"
    [disabled]="disabled()"
    (valueChanges)="selected($event.detail)"
    multiple="true"
    (menuToggle)="menuToggle.emit($event)"
  >
    <ng-container *ngTemplateOutlet="options" />

    @if (footerTemplate) {
      <div slot="footer">
        <ng-container *ngTemplateOutlet="footerTemplate" />
      </div>
    }
  </cw-dropdown>
} @else {
  <!-- we use custom shadow CSS for assistive text, by default cannot grow. But here we need to allow it   -->
  <cw-dropdown
    dropdownMenuToggle
    customShadowCss
    [styles]="safariFix + ' ' + assistiveTextFix"
    [attr.data-vef]="attrVef()"
    [value]="inputTextValue()"
    [placeholder]="placeholder()"
    [label]="label()"
    [assistiveText]="assistiveText() || error()"
    [status]="status() || (error() ? 'error' : null)"
    [required]="required()"
    [readonly]="readonly()"
    [disabled]="disabled()"
    (valueChanges)="selected($event.detail)"
    (menuToggle)="menuToggle.emit($event)"
  >
    <ng-container *ngTemplateOutlet="options" />

    @if (footerTemplate) {
      <div slot="footer">
        <ng-container *ngTemplateOutlet="footerTemplate" />
      </div>
    }
  </cw-dropdown>
}

<ng-template #options>
  @if (loading()) {
    <cw-dropdown-item [disabled]="true" [value]="null" [label]="'Loading' | translate" />
  } @else if (noDataMessage()) {
    <cw-dropdown-item [disabled]="true" [value]="null" [label]="noDataMessage() | translate" />
  } @else {
    <!-- We iterate through the groups -->
    @for (group of groups(); track group?.key) {
      <!-- For not grouped items  -->
      @if (group.key === '_nonGrouped') {
        <!-- We render the items -->
        @for (item of group.items; track item?.id) {
          <ng-container *ngTemplateOutlet="itemTemp; context: { item }" />
        }
      }

      <!-- Else we render the groups -->
      @else {
        <cw-dropdown-group [label]="group.key | translate">
          <!-- We render items -->
          @for (item of group.items; track item) {
            <ng-container *ngTemplateOutlet="itemTemp; context: { item }" />
          }
        </cw-dropdown-group>
      }
    }
  }
</ng-template>

<ng-template #itemTemp let-item="item">
  <!-- 
    Note: If cw-dropdown item has something as a child, does not show the label 
    the same happens when we use @if/*ngIf inside the cw-dropdown-item tag
    for that, we need to check if the item has a template to render it with a ng-container
  
  -->

  @if (itemTemplate) {
    <cw-dropdown-item
      [disabled]="item.disabled"
      [attr.data-vef]="item.attrVef"
      [value]="item"
      [label]="item | printLabel: labelType()"
    >
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item }" />
    </cw-dropdown-item>
  } @else {
    <cw-dropdown-item
      [disabled]="item.disabled"
      [attr.data-vef]="item.attrVef"
      [value]="item"
      [label]="item | printLabel: labelType()"
    />
  }
</ng-template>
